import { useState } from "react";

const useInputCatalogColumnData = () => {
  const [inputValue, setInputValue] = useState<string>("");

  return { inputValue, setInputValue };
};

export default useInputCatalogColumnData;
